import { HttpMethod, apiRequest } from './api'
import type { ApiResponse, PaginatedResponse } from './api'

// 班级类型
export interface ClassData {
  id: number
  name: string
  regionName: string | null
  totalInventory: number
  signUpNum: number
  qrcode: string
  courseId: number
  courseName: string
  championInventory: number
}

// 班级查询参数
export interface ClassQueryParams {
  pageNum?: number
  pageSize?: number
  id?: number
  name?: string
  regionId?: number
  courseId?: number
  afterEndTime?: string
}

// 班级创建请求
export interface ClassCreateRequest {
  name: string
  regionId: number
  totalInventory: number
  championInventory: number
  qrcode: string
  courseId: number
}

// 班级更新请求
export interface ClassUpdateRequest {
  id: number
  name: string
  regionId: number
  totalInventory: number
  championInventory: number
  qrcode: string
  courseId: number
}

// 分页筛选查询班级
export async function getClasses(
  params?: ClassQueryParams,
): Promise<ApiResponse<PaginatedResponse<ClassData>>> {
  const searchParams = new URLSearchParams()

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, String(value))
      }
    })
  }

  const queryString = searchParams.toString()
  const endpoint = queryString ? `/classes?${queryString}` : '/classes'

  return apiRequest<PaginatedResponse<ClassData>>(endpoint, {
    method: HttpMethod.GET,
  })
}

// 添加班级
export async function addClass(
  data: ClassCreateRequest,
): Promise<ApiResponse<number>> {
  return apiRequest<number>('/classes/add', {
    method: HttpMethod.POST,
    body: data,
  })
}

// 更新班级
export async function updateClass(
  data: ClassUpdateRequest,
): Promise<ApiResponse<boolean>> {
  return apiRequest<boolean>('/classes/update', {
    method: HttpMethod.POST,
    body: data,
  })
}

// 添加班级（支持文件上传）
export async function addClassWithFile(
  formData: FormData,
): Promise<ApiResponse<number>> {
  return apiRequest<number>('/classes/add', {
    method: HttpMethod.POST,
    body: formData,
  })
}

// 更新班级（支持文件上传）
export async function updateClassWithFile(
  formData: FormData,
): Promise<ApiResponse<boolean>> {
  return apiRequest<boolean>('/classes/update', {
    method: HttpMethod.POST,
    body: formData,
  })
}

// 删除班级
export async function deleteClass(id: number): Promise<ApiResponse<boolean>> {
  return apiRequest<boolean>(`/classes/delete?id=${id}`, {
    method: HttpMethod.POST,
  })
}
